
import { Options, Vue } from "vue-class-component";
export default class BlogMain extends Vue {
}
